<template>
  <div class="row">
    <div class="col-xs-12 col-md-4">
      <div class="form-field select2">
        <div class="select2-field">
          <v-select
            @input="cargarPuntosEmision"
            v-model="selectedTipoComprobante"
            :options="listaTiposComprobante"
            label="descripcion"
            id="tipoComprobante"
            placeholder="Seleccione..."
          ></v-select>
          <label for="tipoComprobante">Tipo de comprobante</label>
          <input type="hidden" name="tipoComprobante" v-model="form.tipoComprobante" />
        </div>
      </div>
    </div>
    <div v-show="!compras" class="col-xs-12 col-md-4">
      <div class="form-field select2">
        <div class="select2-field">
          <v-select
            @input="setearEstadosComprobante"
            v-model="selectedPuntoEmision"
            :options="puntosEmision"
            label="descripcion"
            id="puntosEmision"
            placeholder="Seleccione..."
          ></v-select>
          <label for="puntosEmision">Puntos de emisión</label>
          <input type="hidden" name="puntoEmision" v-model="form.puntoEmision" />
        </div>
      </div>
    </div>
    <div v-show="!compras" class="col-xs-12 col-md-4">
      <div class="form-inline">
        <label for="comprobantes">
          <input
            @change="changeLogs"
            v-model="form.filtro"
            type="radio"
            name="filtro"
            id="comprobantes"
            value="C"
          />
          <span>Comprobantes</span>
        </label>
        <label for="logs">
          <input
            @change="changeLogs"
            v-model="form.filtro"
            type="radio"
            name="filtro"
            id="logs"
            value="L"
          />
          <span>Logs</span>
        </label>
      </div>
    </div>

    <div v-show="!compras" class="col-xs-12 col-md-4">
      <div class="form-field select2">
        <div class="select2-field">
          <v-select
            @input="inputVendedor"
            id="vendedor"
            v-model="selectedVendedor"
            :options="vendedores"
            label="nombre"
          ></v-select>
          <label for="vendedor">Vendedor</label>
          <input type="hidden" name="vendedorId" v-model="form.vendedorId" />
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field
          name="numeroInicial"
          v-model="form.numeroInicial"
          v-mask="'###-###-#########'"
          placeholder="# Comp (rango inicial)"
          id="numeroInicial"
        >Número de comp.</input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <label for="filtrarPorRangos">
        <p>
          <input
            v-model="form.filtrarPorRangos"
            type="checkbox"
            name="filtrarPorRangos"
            id="filtrarPorRangos"
          />
          <span>Filtrar por rangos de número</span>
        </p>
      </label>
    </div>
    <div v-show="form.filtrarPorRangos" class="col-xs-12 col-md-4">
      <div class="form-field">
        <div class="form-group">
          <input-field
            name="numeroFinal"
            v-model="form.numeroFinal"
            v-mask="'###-###-#########'"
            placeholder="(Para filtrar por rangos)"
            id="numeroFinal"
          >
            <span>Número límite comp.</span>
          </input-field>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field select2">
        <div class="select2-field">
          <v-select
            @input="inputEstadoComprobante"
            v-model="selectedEstadoComprobante"
            :options="estadosComprobante"
            label="value"
            id="estados"
            placeholder="Seleccione..."
          ></v-select>
          <label for="estados">Estados de comprobante</label>
          <input type="hidden" name="estadoComprobante" v-model="form.estadoComprobante" />
        </div>
      </div>
    </div>

    <div v-show="!form.todos" class="col-xs-12 col-md-4">
      <div class="form-field">
        <div class="form-group">
          <input-field
            :disabled="form.idCliente !== ''"
            name="numeroIdentificacion"
            v-model="form.numeroIdentificacion"
            id="numeroIdentificacion"
            placeholder="##########"
          >
            <span>Número de identificación</span>
          </input-field>
          <button
            v-show="form.idCliente === ''"
            @click="cargarPersona"
            type="button"
            class="btn-success"
          >
            <i class="fa fa-check"></i>
          </button>
          <button
            v-show="form.idCliente !== ''"
            @click="quitarCliente"
            type="button"
            class="btn-danger"
          >
            <i class="fa fa-ban"></i>
          </button>
        </div>
      </div>
    </div>
    <div v-show="!form.todos" class="col-xs-12 col-md-4">
      <div class="form-field">
        <div class="form-group">
          <input type="hidden" name="idCliente" :value="form.idCliente">
          <input-field
            name="nombreCliente"
            v-model="form.nombreCliente"
            readonly
            id="numeroIdentificacion"
            placeholder="Seleccione..."
          >
            <span>Persona</span>
          </input-field>
          <button @click="$modal.show('cliente')" type="button" class="btn-info">
            <i class="fa fa-search"></i>
          </button>
          <modal height="auto" width="70%" name="cliente" scrollable>
            <lista-personas :filterStatus="false" @selected="selectedPersona"></lista-personas>
          </modal>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-4">
      <div class="form-inline">
        <label for="todos">
          <input @change="changeTodos" v-model="form.todos" type="checkbox" name="todos" id="todos" />
          <span>Todas las personas</span>
        </label>
        <label for="conDetalles">
          <input v-model="form.conDetalles" type="checkbox" name="conDetalles" id="conDetalles" />
          <span>Mostrar detalles del comp.</span>
        </label>
      </div>
    </div>

    <div class="col-xs-12 col-md-8">
      <div class="form-inline">
        <label>
          <p>
            <strong>Fecha:</strong>
          </p>
        </label>
        <label for="hoy">
          <input v-model="form.tipoFecha" type="radio" name="tipoFecha" id="hoy" value="H" />
          <span>Hoy</span>
        </label>
        <label for="ayer">
          <input v-model="form.tipoFecha" type="radio" name="tipoFecha" id="ayer" value="A" />
          <span>Ayer</span>
        </label>
        <label for="rango">
          <input v-model="form.tipoFecha" type="radio" name="tipoFecha" id="rango" value="R" />
          <span>Filtrar por fechas</span>
        </label>
        <div class="form-field" v-show="form.tipoFecha === 'R'">
          <div class="datepicker-field datepicker-field--stretch">
            <date-picker
              v-model="form.fechaDesde"
              type="date"
              format="dd-MM-yyyy"
              id="desde"
              lang="es"
            ></date-picker>
            <label>Desde</label>
            <input type="hidden" name="fechaDesde" :value="desde" />
          </div>
        </div>
        <div class="form-field" v-show="form.tipoFecha === 'R'">
          <div class="datepicker-field datepicker-field--stretch" v-show="form.tipoFecha === 'R'">
            <date-picker
              name="fechaHasta"
              v-model="form.fechaHasta"
              type="date"
              format="dd-MM-yyyy"
              id="hasta"
              lang="es"
            ></date-picker>
            <label>Hasta</label>
            <input type="hidden" name="fechaHasta" :value="hasta" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field select2">
        <div class="select2-field">
          <v-select id="tiposAbono" v-model="selectedTiposAbono" @input="inputTiposAbono" :options="tiposAbono" label="nombre" placeholder="Seleccione..." multiple></v-select>
          <label for="tiposAbono">Tipos de abono</label>
        </div>
        <input type="hidden" name="tipos_abono[]" v-for="tipoAbono in form.tipos_abono" :key="tipoAbono" :value="tipoAbono">
      </div>
    </div>
    <div class="col-xs-12 col-md-8">
      <div class="form-inline">
          <label for="pendientesPago">
            <input
              v-model="form.pendientesPago"
              type="checkbox"
              name="pendientesPago"
              id="pendientesPago"
              @change="changePendientesPago"
            />
          <span>Mostrar pendientes de pago</span>
          </label>
          <label for="pagados">
            <input
              @change="changePagados"
              v-model="form.pagados"
              type="checkbox"
              name="pagados"
              id="pagados"
            />
            <span>Mostrar pagados</span>
          </label>
          <label for="abonados">
              <input
                @change="changeConAbonos"
                v-model="form.abonados"
                type="checkbox"
                name="abonados"
                id="abonados"
              />
              <span>Mostrar abonos</span>
          </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tipos_abono: {
      type: Array,
      required: false,
      default: function () {
        return [];
      }
    },
    pagados: {
      type: Boolean,
      required: false,
      default: false
    },
    abonados: {
      type: Boolean,
      required: false,
      default: false
    },
    filtro: {
      type: String,
      required: false
    },
    tipoFecha: {
      type: String,
      required: true
    },
    fechaDesde: {
      type: String,
      required: true
    },
    fechaHasta: {
      type: String,
      required: true
    },
    numeroInicial: {
      type: String,
      required: true
    },
    numeroFinal: {
      type: String,
      required: true
    },
    estadoComprobante: {
      type: String,
      required: false
    },
    todos: {
      type: Boolean,
      required: true
    },
    numeroIdentificacion: {
      type: String,
      required: true
    },
    nombreCliente: {
      type: String,
      required: true
    },
    idCliente: {
      type: String,
      required: true
    },
    tipoComprobante: {
      type: String,
      required: true
    },
    tiposComprobante: {
      type: Array,
      required: true
    },
    puntoEmision: {
      type: String,
      required: false
    },
    conDetalles: {
      type: Boolean,
      required: true
    },
    compras: {
      type: Boolean,
      required: false
    },
    filtrarPorRangos: {
      type: Boolean,
      required: false,
      default: false
    },
    pendientesPago: {
      type: Boolean,
      required: false,
      default: false
    },
    vendedorId: {
      type: String,
      required: false,
      default: ""
    },
    vendedores: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    desde: function() {
      return moment(this.form.fechaDesde).format("YYYY-MM-DD");
    },
    hasta: function() {
      return moment(this.form.fechaHasta).format("YYYY-MM-DD");
    },
    visualizarPendientesPago: function() {
      return (
        this.selectedTipoComprobante !== null &&
        this.selectedTipoComprobante.id_tipo_comprobante === "01"
      );
    }
  },
  data: function() {
    return {
      selectedTiposAbono: [],
      tiposAbono: [
                {
                    id : 'EF',
                    nombre : 'Efectivo'
                },
                {
                    id : 'CH',
                    nombre : 'Cheque'
                },
                {
                    id : 'DEP',
                    nombre : 'Depósito bancario'
                },
                {
                    id : 'CRE',
                    nombre : 'Tarjeta de crédito'
                },
                {
                    id : 'DEB',
                    nombre : 'Tarjeta de débito'
                },
                {
                    id : 'TRANS',
                    nombre : 'Transferencia'
                },
                {
                    id : 'RET',
                    nombre : 'Retención'
                }
            ],
      selectedVendedor: null,
      form: {
        filtro: this.filtro,
        tipoFecha: this.tipoFecha,
        fechaDesde: moment(new Date(this.fechaDesde + " 00:00:00")).format(
          "YYYY-MM-DD"
        ),
        fechaHasta: moment(new Date(this.fechaHasta + " 00:00:00")).format(
          "YYYY-MM-DD"
        ),
        numeroInicial: this.numeroInicial,
        numeroFinal: this.numeroFinal,
        estadoComprobante: this.estadoComprobante,
        todos: this.todos,
        numeroIdentificacion: this.numeroIdentificacion,
        nombreCliente: this.nombreCliente,
        idCliente: this.idCliente,
        puntoEmision: this.puntoEmision,
        conDetalles: this.conDetalles,
        filtrarPorRangos: this.filtrarPorRangos,
        pendientesPago: this.pendientesPago,
        tipoComprobante: this.tipoComprobante,
        vendedorId: this.vendedorId,
        pagados: this.pagados,
        abonados: this.abonados,
        tipos_abono: this.tipos_abono
      },
      selectedTipoComprobante: null,
      estadosComprobante: [],
      selectedEstadoComprobante: null,
      puntosEmision: [],
      selectedPuntoEmision: null,
      url: url,
      cargaInicial: false,
      comprobantesElectronicos: [],
      listaTiposComprobante: this.tiposComprobante
    };
  },
  methods: {
    inputTiposAbono: function () {
      this.form.tipos_abono.splice(0, this.form.tipos_abono.length);
      for (let i = 0; i < this.selectedTiposAbono.length; i++) {
        this.form.tipos_abono.push(this.selectedTiposAbono[i].id);
      }
    },
    changeConAbonos: function () {
      if (this.form.abonados) this.form.conDetalles = false;
    },
    changePendientesPago: function () {
      if (this.form.pendientesPago) this.form.pagados = false;
    },
    changePagados: function () {
      if (this.form.pagados) this.form.pendientesPago = false;
    },
    inputVendedor: function() {
      if (this.selectedVendedor !== null)
        this.form.vendedorId = this.selectedVendedor.id;
      else this.form.vendedorId = "";
    },
    selectedPersona: function(persona) {
      this.form.nombreCliente = persona.nombre;
      this.form.numeroIdentificacion = persona.identificacion;
      this.form.idCliente = persona.id;
      this.$modal.hide("cliente");
    },
    quitarCliente: function() {
      this.form.nombreCliente = "";
      this.form.idCliente = "";
      this.form.numeroIdentificacion = "";
    },
    cargarPersona: function() {
      let that = this;
      if (this.form.numeroIdentificacion !== "") {
        axios
          .get(this.url + "/personas/" + this.form.numeroIdentificacion)
          .then(function(response) {
            that.form.nombreCliente = response.data.nombre;
            that.form.idCliente = response.data.id;
          })
          .catch(function(error) {
            if (error !== undefined && error !== null) {
              let response = error.response;
              if (response !== undefined && response !== null) {
                if (response.status === 404)
                  swal("No existe el cliente solicitado.", "Aviso", "warning");
                else
                  swal(
                    "Hubo un error al solicitar el cliente.",
                    "Error",
                    "error"
                  );
              }
            }
          });
      } else
        swal(
          "Debe ingresar el identificador del cliente.",
          "Mensaje",
          "warning"
        );
    },
    inputEstadoComprobante: function() {
      if (
        this.selectedEstadoComprobante !== null &&
        this.selectedEstadoComprobante !== undefined
      )
        this.form.estadoComprobante = this.selectedEstadoComprobante.id;
      else this.form.estadoComprobante = "";
    },
    obtenerEstadosManuales: function() {
      return [
        {
          id: "T",
          value: "Todos"
        },
        {
          id: "E",
          value: "Emitidos"
        },
        {
          id: "A",
          value: "Anulados"
        }
      ];
    },
    obtenerEstadosCompras: function() {
      return [
        {
          id: "T",
          value: "Todos"
        },
        {
          id: "A",
          value: "Autorizados"
        },
        {
          id: "I",
          value: "Anulados"
        }
      ];
    },
    obtenerEstadosElectronicos: function() {
      return [
        {
          id: "T",
          value: "Todos"
        },
        {
          id: "E",
          value: "Emitidos"
        },
        {
          id: "PPR",
          value: "Pendientes"
        },
        {
          id: "AUT",
          value: "Autorizados"
        },
        {
          id: "NAT",
          value: "No autorizados"
        },
        {
          id: "A",
          value: "Anulados"
        }
      ];
    },
    cargarPuntosEmision: function() {
      if (
        this.selectedTipoComprobante !== null &&
        this.selectedTipoComprobante !== undefined
      ) {
        this.form.tipoComprobante = this.selectedTipoComprobante.id_tipo_comprobante;
        let that = this;
        axios
          .get(
            this.url +
              "/puntos-emision/" +
              this.form.tipoComprobante +
              "/lista",
            {
              params: {
                filtro: this.form.filtro
              }
            }
          )
          .then(function(response) {
            that.puntosEmision = response.data;
            if (!that.cargaInicial) that.selectedPuntoEmision = null;
            else {
              for (let i = 0; i < that.puntosEmision.length; i++)
                if (that.puntosEmision[i].id === that.puntoEmision) {
                  that.selectedPuntoEmision = that.puntosEmision[i];
                  break;
                }
            }
            that.cargaInicial = false;
          });
      } else {
        this.selectedPuntoEmision = null;
        this.form.tipoComprobante = "";
        this.puntosEmision = [];
      }
    },

    setearEstadosComprobante: function() {
      if (
        this.selectedPuntoEmision !== undefined &&
        this.selectedPuntoEmision !== null
      ) {
        this.form.puntoEmision = this.selectedPuntoEmision.id;
        if (this.selectedPuntoEmision.tipo === "M")
          this.estadosComprobante = this.obtenerEstadosManuales();
        else this.estadosComprobante = this.obtenerEstadosElectronicos();
        if (!this.cargaInicial)
          for (let i = 0; i < this.estadosComprobante.length; i++)
            if (this.estadosComprobante[i].id === this.estadoComprobante) {
              this.selectedEstadoComprobante = this.estadosComprobante[i];
              break;
            }
      } else {
        this.selectedEstadoComprobante = null;
        this.estadosComprobante = [];
        this.form.puntoEmision = "";
      }
    },
    changeTodos: function() {
      if (this.todos) {
        this.form.idCliente = "";
        this.form.nombreCliente = "";
        this.form.numeroIdentificacion = "";
      }
    },
    changeLogs: function() {
      if (this.form.filtro === "L") {
        if (
          this.selectedTipoComprobante !== null &&
          this.selectedTipoComprobante !== undefined
        ) {
          let existe = false;
          for (let i = 0; i < this.comprobantesElectronicos.length; i++)
            if (
              this.comprobantesElectronicos[i].id_tipo_comprobante ===
              this.selectedTipoComprobante.id_tipo_comprobante
            ) {
              existe = true;
              break;
            }
          if (!existe) this.selectedTipoComprobante = null;
        }
        this.listaTiposComprobante = this.comprobantesElectronicos;
      } else this.listaTiposComprobante = this.tiposComprobante;
    }
  },
  mounted: function() {
    this.cargaInicial = true;
    if (this.tipoComprobante !== "") {
      for (let i = 0; i < this.tiposComprobante.length; i++) {
        if (
          this.tiposComprobante[i].id_tipo_comprobante === this.tipoComprobante
        ) {
          this.selectedTipoComprobante = this.tiposComprobante[i];
          break;
        }
      }
    }
    for (let i = 0; i < this.tiposComprobante.length; i++) {
      if (
        this.tiposComprobante[i].id_tipo_comprobante !== "00" &&
        this.tiposComprobante[i].id_tipo_comprobante !== "99"
      )
        this.comprobantesElectronicos.push(this.tiposComprobante[i]);
    }
    this.changeLogs();
    if (this.compras) {
      this.estadosComprobante = this.obtenerEstadosCompras();
      for (let i = 0; i < this.estadosComprobante.length; i++)
        if (this.estadosComprobante[i].id === this.estadoComprobante) {
          this.selectedEstadoComprobante = this.estadosComprobante[i];
          break;
        }
    } else {
      for (let i = 0; i < this.vendedores.length; i++)
        if (this.vendedores[i].id == this.form.vendedorId) {
          this.selectedVendedor = this.vendedores[i];
          break;
        }
    }
    this.selectedTiposAbono.splice(0, this.selectedTiposAbono.length);
    if (this.form.tipos_abono.length > 0) {
      for (let i = 0; i < this.form.tipos_abono.length; i++) {
        for (let j = 0; j < this.tiposAbono.length; j++) {
          if (this.tiposAbono[j].id == this.form.tipos_abono[i]) 
          {
            this.selectedTiposAbono.push(this.tiposAbono[j]);
            break;
          }
        }
      }
    }
  },
  
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/FiltroComprobantes.vue